import { merge, partial, spread } from 'lodash';

import { loadedNameSpaces } from './loadedNameSpaces';

import type {
  I18nResource,
  LoadedResources,
  NameSpace,
  Translation,
  Translations,
} from './locales.types';
import type { SupportedLocaleType } from './SupportedLocale.type';

export const adaptLoadedResources = () => {
  const flatNameSpaces = Object.entries(loadedNameSpaces) as [
    NameSpace,
    LoadedResources,
  ][];
  const flatResources = flatNameSpaces.map(nameSpace => {
    const locales = Object.entries(nameSpace[1]) as [
      SupportedLocaleType,
      Translation,
    ][];
    const resource: I18nResource = {} as I18nResource;
    for (const locale of locales) {
      resource[locale[0]] = {
        [`${nameSpace[0]}`]: locale[1],
      } as Translations;
    }
    return resource;
  });

  return spread(partial(merge, {}))(flatResources);
};
